/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_CropInputs */

const cs_enum_crop = /** @type {(inputs: Enum_CropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ořez`)
};

const en_enum_crop = /** @type {(inputs: Enum_CropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crop`)
};

/**
* | output |
* | --- |
* | "Crop" |
*
* @param {Enum_CropInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_crop = /** @type {((inputs?: Enum_CropInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_CropInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_crop(inputs)
	return cs_enum_crop(inputs)
});